import { Controller } from 'stimulus';

const TomSelect = require('../lib/tom_select');

// Shows/hides the sections of the notification-rule form that only apply to
// certain event kinds (job scope, date offsets, stuck days, member role),
// and upgrades the criteria/recipient multi-selects to TomSelect.
// Event metadata comes from data-event-metadata (JSON keyed by event_key).
export default class extends Controller {
  static targets = ['eventSelect', 'scopeSection', 'offsetsSection', 'stuckSection',
                    'memberRoleSection', 'criteriaSection', 'scopeKind', 'statusParamsSection'];

  connect() {
    this.metadata = JSON.parse(this.element.dataset.eventMetadata || '{}');
    this.initMultiSelects();
    this.refresh();
  }

  disconnect() {
    (this.tomSelectInstances || []).forEach((ts) => ts.destroy());
    this.tomSelectInstances = [];
  }

  initMultiSelects() {
    this.tomSelectInstances = [];
    this.element.querySelectorAll('[data-notification-rule-multi]').forEach((el) => {
      const ts = new TomSelect(el, {
        plugins: ['remove_button'],
        persist: false,
        maxItems: null,
        hideSelected: true,
        placeholder: el.dataset.placeholder,
        onItemAdd: function () {
          this.setTextboxValue('');
          this.refreshOptions(false);
        },
      });
      this.tomSelectInstances.push(ts);
    });
  }

  eventChanged() {
    this.refresh();
  }

  scopeKindChanged() {
    this.refresh();
  }

  refresh() {
    const meta = this.currentMetadata();

    this.toggle(this.scopeSectionTargets, meta.job_scoped);
    this.toggle(this.offsetsSectionTargets, meta.kind === 'date');
    this.toggle(this.stuckSectionTargets, meta.kind === 'stuck');
    this.toggle(this.memberRoleSectionTargets, this.currentEventKey() === 'added_to_job');
    this.toggle(this.statusParamsSectionTargets, this.currentEventKey() === 'job_status_changed');
    this.toggle(this.criteriaSectionTargets, meta.job_scoped && this.currentScopeKind() === 'criteria');
  }

  currentEventKey() {
    if (!this.hasEventSelectTarget) { return this.element.dataset.eventKey; }

    return this.eventSelectTarget.value;
  }

  currentMetadata() {
    return this.metadata[this.currentEventKey()] || {};
  }

  currentScopeKind() {
    const checked = this.scopeKindTargets.find((input) => input.checked);
    return checked ? checked.value : 'involved';
  }

  toggle(elements, show) {
    elements.forEach((el) => el.classList.toggle('hidden', !show));
  }
}
